import { Route } from '@angular/router';
import { LoginGuard } from 'src/shared/guards/login.guard';
import { usaDashboardRoutes } from './dashboard/usa-dashboard-routing';

export const usaRoutes: Route[] = [
  {
    path: 'us',
    children: [...usaDashboardRoutes],
    canActivate: [LoginGuard],
  },
];
